import { classValidatorResolver } from "@hookform/resolvers/class-validator";
import { router } from "expo-router";
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { View, SafeAreaView } from "react-native";
import { useDispatch } from "react-redux";

import Logo from "@/assets/logo.svg";
import Loader from "@/components/Loader";
import Title from "@/components/Title";
import Button from "@/components/button/Button";
import Input from "@/components/input/Input";
import InputPassword from "@/components/input/InputPassword";
import { setForm } from "@/context/actions/actions";
import { loginHandler } from "@/screens/Login";
import { sendRequest } from "@/utils/ApiUtil";
import { CreateUserRequest } from "@/utils/dto/user.request";

type FormData = {
  username: string;
  email: string;
  password: string;
};

export default function SignUp() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const resolver = classValidatorResolver(CreateUserRequest, {
    validator: { skipMissingProperties: true },
  });

  const { control, handleSubmit, formState, reset } = useForm<FormData>({
    mode: "onBlur",
    resolver,
  });

  const { isSubmitting } = formState;

  const onSubmit = async (data: FormData) => {
    try {
      const request = await sendRequest("post", "/create-user", data);
      dispatch(setForm({ email: data.email, password: data.password }));
      if (request) {
        reset();
        await loginHandler({
          email: data.email,
          password: data.password,
        });
        router.replace("/validate");
      }
    } catch (error: any) {
      console.log(error);
    }
  };

  return (
    <SafeAreaView className="grow bg-white1">
      <View className="items-center justify-center w-full h-full">
        <Logo className="mt-4" />
        <View className="flex-grow w-full items-center justify-center">
          <View className="m-2">
            <Title text={t("signup:title")} />
          </View>
          <View className="w-full items-center">
            <Input
              label={t("signup:username")}
              control={control}
              name="username"
            />
            <Input label={t("signup:email")} control={control} name="email" />
            <InputPassword
              label={t("signup:password")}
              control={control}
              name="password"
              hidden
            />
          </View>
          <Button
            label={t("common:button.signup")}
            onClick={handleSubmit(onSubmit)}
          />
        </View>
        {isSubmitting && <Loader />}
      </View>
    </SafeAreaView>
  );
}
